<div class="container-fluid">
  <div class="row">
      <div class="col-12">
          <div class="card">
              <div class="card-header" style="padding-bottom: 5px !important">
                  <div >
                      <h5 class="pb-2">احصائيات تبرعات الاونلاين</h5>
                  </div>
                  <ng-template >
                      
                  </ng-template>
              </div>
              <div class="card-body">

                      <div class="form-row">
                        <div class="col-6 col-md-6">
                          <div class="form-group">
                              <label for="">   من تاريخ  </label>
                             <input type="date" [(ngModel)]="SearchForm.fromDate"   class="form-control" >
                          </div>
                      </div>
                      <div class="col-6 col-md-6">
                          <div class="form-group">
                              <label for="">    الى تاريخ </label>                            
                              <input type="date" [(ngModel)]="SearchForm.toDate" class="form-control" >
                          </div>
                     </div>  
                          <div class="col-6 mb-3">
                              <label for="validationCustom05">المشروع  </label>
                              <ng-select #Governorate  [selectOnTab]="true" [(ngModel)]="SearchForm.project"
                                  class="form-control p-0" placeholder="اختر المشروع"
                                  containerClass="" 
                                  id="validationCustom05">
                                  <ng-option *ngFor="let item of projects" [value]="item.id">{{item.title}}</ng-option>
                              </ng-select>
                          </div>
                          <div class="col-6 mb-3">
                              <label for="validation01">الكود المرجعي</label>
                                  <!-- <input class="form-control" id="validation01" type="text" [(ngModel)]="ReportsInfo.RefCodeID" containerClass="" /> -->
                                    <ng-select class="form-control p-0" aria-label="Default select example"
                                    [(ngModel)]="SearchForm.refCode"  [items]="RefCodes"
                                    bindLabel="refCode" bindValue="id">
                                  </ng-select>
                          </div>
                      </div>                      
                          <button  class="btn pull-right" type="button" (click)="onSubmit()">
                             بحث
                          </button>
                     
              </div>
          </div>
          <div >
            <div class="row">
              <div class="col-6">
              <div class="card  small-widget mb-sm-0">
              <div class="card-body primary text-center">
                <h5  class="DarkBlueMrscoolColor"># التبرعات</h5>
                <div >
                  <h5 class="DarkBlueMrscoolColor">{{OnlineDonationState?.donationNumbers.donations}} </h5>
                 
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use href="assets/svg/icon-sprite.svg#fill-file"></use>
                  </svg>
                </div>
              </div>
              </div>
            </div>
            <div class="col-6">
              <div class="card small-widget mb-sm-0">
              <div class="card-body success text-center">
                <h5  class="DarkBlueMrscoolColor">مبلغ التبرعات </h5>
                <div >
                  <h5  class="DarkBlueMrscoolColor">{{OnlineDonationState?.donationNumbers.amountOfDonations }} ج . م</h5>
                 
                </div>
                <div class="bg-gradient">
                  <svg class="stroke-icon svg-fill">
                    <use href="assets/svg/icon-sprite.svg#new-order"></use>
                  </svg>
                </div>
              </div>
              </div>
            </div> 
            </div>
           
          </div>
       
      </div>
      <div class="col-12 mt-5">
        <div class="table-responsive text-center">
          <table class="table table-responsive-sm">
              <thead>
                  <tr class=" ">
                      <th scope="col"></th>
                      <th scope="col">الكود المرجعي</th>
                      <th scope="col">المشروع</th>
                      <th scope="col">عدد التبرعات</th>
                      <th scope="col">مبلغ التبرعات</th>
                      <th scope="col">عدد مشاهدات المشروع</th>
                      <th scope="col">عدد مشاهدات الدفع</th>
                      <th scope="col">الدفع</th>

                      <th scope="col"></th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let view of OnlineDonationState?.donationList;let x = index" class=" trTbH">
                      <td scope="row" class="p-2">{{x+1}}</td>
                      <td class="p-2">{{view.refCode}}</td>
                      <td class="p-2">{{view.project}}</td>
                      <td class="p-2">{{view.numberOfDonations}}</td>
                      <td class="p-2">{{view.totalDonationAmount}}</td>
                      <td class="p-2">{{view.projectViewCount}}</td>
                      <td class="p-2">{{view.projectPaymentViewCount}}</td>
                      <td class="p-2">{{view.numberofPaymentviews}}</td>
                      </tr>
              </tbody>
          </table>
      </div>
      </div>
      
  </div>
</div>

